import { z } from 'zod'

export const fuzzyNumberToNumber = z
  .union([z.string(), z.number(), z.null()])
  .transform((value) => (value === '' ? null : value))
  .pipe(z.coerce.number())

export const fuzzyNumberToString = z
  .union([z.string(), z.number(), z.null()])
  .nullable()
  .transform((value) => {
    return value !== null ? value.toString() : ''
  })
  .pipe(z.coerce.string())
